import { gql } from '@apollo/client';

const UPDATE_FACILITY_NOTE_MUTATION = gql`
  mutation updateFacilityNote($id: ID!, $note: String) {
    updateFacilityNote(id: $id, note: $note) {
      isSuccess
      message
      facility {
        facilityNote
      }
    }
  }
`;

export default UPDATE_FACILITY_NOTE_MUTATION;
